package org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.bill_search.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.statistic_data.BillSearchStatisticDataItem

@Composable
fun SelectedBillSearchItemDetailContent(
    modifier: Modifier=Modifier,
    selectedBillSearchItem:BillSearchStatisticDataItem?,
)
{
    Column(
        modifier = modifier
            .fillMaxWidth()
    )
    {

        SpanText(
            text =selectedBillSearchItem?.userName?:"",
            modifier=Modifier
                .margin(
                    bottom = Dimen.largePadding,
                    top = Dimen.normalPadding,
                )
                .color(Theme.TextPrimary.rgb)
                .fontSize(FontSizes.extraExtraLargeFontSize)
                .fontWeight(FontWeight.Medium)
                .fontFamily(FontFamily.Jakarta)
        )

        SelectedBillSearchItemDetailTable(
            selectedBillSearchItem = selectedBillSearchItem
        )



    }


}